// export const url = "https://www.versatileapparels.com";
// export const url = "https://keshfashion.pythonanywhere.com";
// export const url = "http://127.0.0.1:8000";
export const url = "https://api.versatileapparels.com";
